import type { CALENDAR_TYPE } from "../Models/Common";

import useCalendarsStore from "../Store";

import { removeIntegration } from "@/Services/TherapyApi/Calendars";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

const RemoveIntegrationActionHandler = async (
  provider: CALENDAR_TYPE,
  integrationId: string
): Promise<true | undefined> => {
  const calendarsStore = useCalendarsStore();

  const resp = await removeIntegration(provider, integrationId);
  if (isApiError(resp)) return undefined;

  calendarsStore.calendars = calendarsStore.calendars.filter((c) => c.integrationUuid !== integrationId);

  return true;
};

export default RemoveIntegrationActionHandler;
